<template>
  <div class="eq-settings">
    <SaltItem title="均衡器" :description="equalizer.message"><template #trailing><SaltSwitch aria-label="均衡器" :value="equalizer.enabled" :disabled="toggling" @change="toggle" /></template></SaltItem>
    <SaltItem title="音效设置保存位置" description="保存预设与频段；开启状态由本设备控制。"><template #trailing><SaltSelect aria-label="音效设置保存位置" :value="preference.state.storage" :disabled="preference.state.busy" @change="storage"><option value="local">此浏览器本地</option><option value="cloud" :disabled="!site.user">云端账号{{ site.user ? '' : '（请先登录）' }}</option></SaltSelect></template></SaltItem>
    <p v-if="preference.state.error" class="eq-error" role="status">{{ preference.state.error }}</p>
    <template v-if="equalizer.enabled">
      <SaltItem title="音效预设" :description="equalizer.active ? '正在处理本地音频' : '当前为原音播放'"><template #trailing><SaltSelect aria-label="音效预设" :value="equalizer.preset" @change="preset"><option v-for="(item, id) in presets" :key="id" :value="id">{{ item.label }}</option><option v-if="equalizer.preset === 'custom'" value="custom">自定义</option></SaltSelect></template></SaltItem>
      <div class="eq-bands" aria-label="自定义均衡器">
        <div v-for="(frequency, index) in frequencies" :key="frequency" class="eq-band">
          <label :for="'eq-' + index">{{ frequency >= 1000 ? (frequency / 1000) + 'k' : frequency }} Hz</label>
          <SaltSlider :id="'eq-' + index" :min="-12" :max="12" :step="1" :value="equalizer.gains[index]" :aria-label="frequency + ' Hz 增益'" @input="band(index, $event)" />
          <output>{{ equalizer.gains[index] > 0 ? '+' : '' }}{{ equalizer.gains[index] }} dB</output>
        </div>
      </div>
    </template>
  </div>
</template>
<script>
import SaltItem from './ui/SaltItem.vue';
import SaltSwitch from './ui/SaltSwitch.vue';
import SaltSelect from './ui/SaltSelect.vue';
import SaltSlider from './ui/SaltSlider.vue';
import { runtime } from '../bridge';
import { equalizer, eqFrequencies, eqPresets, eqPreference, enableEqualizer, disableEqualizer, setEqualizerPreset, setEqualizerBand } from '../equalizer';
import { siteAccount } from '../site-account';
export default {
  name: 'EqualizerSettings', components: { SaltItem, SaltSwitch, SaltSelect, SaltSlider },
  data() { return { equalizer, preference: eqPreference, site: siteAccount, frequencies: eqFrequencies, presets: eqPresets, toggling: false }; },
  methods: {
    async toggle(value) {
      if (this.toggling) return;
      this.toggling = true;
      try {
        if (value) { if (!await enableEqualizer()) return; } else disableEqualizer();
        await runtime.applyEqualizerToCurrentTrack();
      } finally { this.toggling = false; }
    },
    preset(value) { setEqualizerPreset(value); },
    band(index, value) { setEqualizerBand(index, Number(value)); },
    storage(value) { return eqPreference.select(value); },
  },
};
</script>
<style scoped>
.eq-bands { padding: 8px 16px 16px; max-width: 640px; }
.eq-band { display: grid; grid-template-columns: 70px minmax(80px, 1fr) 52px; align-items: center; gap: 12px; min-height: 36px; font-size: 13px; }
.eq-band output { text-align: right; font-variant-numeric: tabular-nums; }
.eq-error { margin:0; padding:0 16px 8px; color:var(--salt-error,#c42b1c); font-size:12px; }
</style>
